import BCComponent from "./bc_component";
import {bindActionCreators} from "redux";
import {getBonusTasks, submitBonusTask} from "game/app/actions/bonus-tasks-actions";
import connect from "react-redux/es/connect/connect";
import React from "react";

class Oblast3 extends BCComponent {

    render() {
        return (
            <div>
                <h3>Oblast 3 – KVÍZY A PRACOVNÍ LISTY</h3>
                <div className='separate-bottom'>
                    <p>Kvíz (test) se dá použít k ověření znalostí nebo také k zamyšlení nad daným tématem a k získání nových informací.</p>
                    <p>Pracovní listy slouží k upevnění nabytých znalostí, k procvičení dovedností a také k hlubšímu zamyšlení nad daným tématem. Je to <b>výborný nástroj pro samostatnou práci na svém vzdělávání nebo pro zpracování skupinových úkolů. DUM = digitální učební materiál</b> je moderní verze pracovních listů v digitální formě.</p>
                </div>

                <h4>Znalostní úkoly</h4>
                { this.showTask('kvizy_1') }

                <h4>Tvořivé úkoly</h4>
                { this.showTask('kvizy_3') }

                <hr className='separate'/>
            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Oblast3);
